var React = require('react');

function S07 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"s-08","transform":"translate(-0.182)"},[React.createElement("rect",{"id":"Rectangle_48496","data-name":"Rectangle 48496","width":"28","height":"28","transform":"translate(0.182)","fill":"none","key":0}),React.createElement("path",{"id":"Path_106568","data-name":"Path 106568","d":"M23.995,2.82c-.6-.6-1.362-1.349-14.178,10.538L3.2,16.718a.82.82,0,0,0-.458.738c0,2.965,3.653,6.618,6.618,6.618a.835.835,0,0,0,.738-.458l3.36-6.605C25.344,4.182,24.593,3.431,23.995,2.82ZM12.744,15.344l-1.26-1.26c3.5-3.22,7.255-6.5,9.622-8.362C19.247,8.089,15.976,11.844,12.744,15.344ZM8.875,22.382a6.507,6.507,0,0,1-4.429-4.429l5.689-2.889,1.629,1.629Z","transform":"translate(0.747 0.692)","key":1})]));
}

S07.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = S07;

S07.default = S07;
